import * as React from 'react';

import type {SalesDocumentType} from '../../lead-sidebar/sales-documents/types';
import {Body} from '../../typography/body';

import styles from '../quote.module.css';

type Props = {
    type: SalesDocumentType;
    displayNumber: string;
    preparedBy: string;
    preparedTimeFormatted: string;
    validUntilDateFormatted: string;
    purchaseOrderNumber?: string | null | undefined;
    jobNumber?: string | null | undefined;
    customerNumber?: string | null | undefined;
    referenceNumber?: string | null | undefined;
};

export function QuoteInfo(props: Props) {
    const isInvoice = props.type === 'Invoice';
    const displayName = isInvoice ? 'Invoice' : 'Quote';

    const config = [
        {
            title: `${displayName} number`,
            value: props.displayNumber,
        },
    ];

    if (props.purchaseOrderNumber != null) {
        config.push({
            title: 'Purchase order #',
            value: props.purchaseOrderNumber,
        });
    }

    if (props.jobNumber != null) {
        config.push({
            title: 'Job #',
            value: props.jobNumber,
        });
    }

    if (props.customerNumber != null) {
        config.push({
            title: 'Customer #',
            value: props.customerNumber,
        });
    }

    if (props.referenceNumber != null) {
        config.push({
            title: 'Reference #',
            value: props.referenceNumber,
        });
    }

    config.push(
        {
            title: 'Prepared by',
            value: props.preparedBy,
        },
        {
            title: isInvoice ? 'Date issued' : 'Prepared on',
            value: props.preparedTimeFormatted,
        },
        {
            title: isInvoice ? 'Due date' : 'Valid through',
            value: props.validUntilDateFormatted,
        }
    );

    return (
        <div className={styles['quote-info-container']}>
            <div className='full-width flex flex-dir-col gap-4'>
                {config.map((info) => (
                    <div key={info.title} className='flex gap-8'>
                        <div className={styles['quote-info-label']}>
                            <Body as='div'>{info.title}</Body>
                        </div>
                        <Body as='div' color='dark' isBold={true}>
                            {info.value}
                        </Body>
                    </div>
                ))}
            </div>
        </div>
    );
}
